import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import App from './App';

const container = document.getElementById('root');

const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

/*
 * A production build ships markup rendered by ReactDOMServer
 * (scripts/prerender.js), so it is hydrated: React adopts the existing DOM
 * instead of discarding it and rebuilding the tree.
 *
 * This only became possible once prerendering moved off a headless browser.
 * The earlier version snapshotted a live client DOM, which cannot be
 * hydrated — adjacent text nodes merge into one when HTML is reparsed, and
 * portal containers hold nodes React did not create — so every route failed
 * with React errors #418/#423 and fell back to client rendering anyway.
 * ReactDOMServer emits exactly what hydration expects.
 *
 * `firstElementChild`, not `hasChildNodes`: the shell contains an inert
 * `<!--!body-->` comment, which counts as a child node and would send an
 * un-prerendered build (the dev server) down the hydration path.
 */
if (container.firstElementChild) {
  hydrateRoot(container, app);
} else {
  createRoot(container).render(app);
}
